/**
 * vue-select renders a placeholder <ul role="listbox"> with display:none when the
 * dropdown is closed, while the combobox keeps aria-owns / aria-controls pointing
 * to that node. Assistive tech can still surface it in reading order, causing
 * confusing announcements (e.g. document title). Mark visually hidden listboxes
 * so they are not exposed when closed.
 */
export function syncVueSelectListboxAriaHidden() {
  if (typeof document === "undefined" || typeof window === "undefined") return

  document.querySelectorAll('ul[role="listbox"]').forEach((ul) => {
    if (!/^vs\d+__listbox$/.test(ul.id)) return
    const style = window.getComputedStyle(ul)
    const isHidden = style.display === "none" || style.visibility === "hidden"

    if (isHidden) {
      ul.setAttribute("aria-hidden", "true")
    } else {
      ul.removeAttribute("aria-hidden")
    }
  })
}
